'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var VimStatusBar = function () {
  function VimStatusBar(node, editor) {
    var _this = this;
    _classCallCheck(this, VimStatusBar);
    this.closeInput = function () {
      _this.removeInputListeners();
      _this.input = null;
      _this.setSec('');
      if (_this.editor) {
        _this.editor.focus();
      }
    };
    this.inputKeyUp = function (e) {
      var options = _this.input.options;
      if (options && options.onKeyUp) {
        options.onKeyUp(e, e.target.value, _this.closeInput);
      }
    };
    this.inputBlur = function () {
      var options = _this.input.options;
      if (options.closeOnBlur) {
        _this.closeInput();
      }
    };
    this.inputKeyDown = function (e) {
      var _input = _this.input,
        options = _input.options,
        callback = _input.callback;
      if (options && options.onKeyDown && options.onKeyDown(e, e.target.value, _this.closeInput)) {
        return;
      }
      if (e.keyCode === 27 || options && options.closeOnEnter !== false && e.keyCode == 13) {
        _this.input.node.blur();
        e.stopPropagation();
        _this.closeInput();
      }
      if (e.keyCode === 13 && callback) {
        e.stopPropagation();
        e.preventDefault();
        callback(e.target.value);
      }
    };
    this.node = node;
    this.modeInfoNode = document.createElement('span');
    this.secInfoNode = document.createElement('span');
    this.notifNode = document.createElement('span');
    this.notifNode.className = 'vim-notification';
    this.keyInfoNode = document.createElement('span');
    this.keyInfoNode.setAttribute('style', 'float: right');
    this.node.appendChild(this.modeInfoNode);
    this.node.appendChild(this.secInfoNode);
    this.node.appendChild(this.notifNode);
    this.node.appendChild(this.keyInfoNode);
    this.toggleVisibility(false);
    this.editor = editor;
  }
  _createClass(VimStatusBar, [{
    key: 'setMode',
    value: function setMode(ev) {
      if (ev.mode === 'visual' && ev.subMode === 'linewise') {
        this.setText('--VISUAL LINE--');
        return;
      }
      this.setText('--' + ev.mode.toUpperCase() + '--');
    }
  }, {
    key: 'setKeyBuffer',
    value: function setKeyBuffer(key) {
      this.keyInfoNode.textContent = key;
    }
  }, {
    key: 'setSec',
    value: function setSec(text, callback, options) {
      this.notifNode.textContent = '';
      if (text === undefined) {
        return;
      }
      this.secInfoNode.innerHTML = text;
      var input = this.secInfoNode.querySelector('input');
      if (input) {
        input.focus();
        this.input = {
          callback: callback,
          options: options,
          node: input
        };
        if (options) {
          if (options.selectValueOnOpen) {
            input.select();
          }
          if (options.value) {
            input.value = options.value;
          }
        }
        this.addInputListeners();
      }
      return this.closeInput;
    }
  }, {
    key: 'setText',
    value: function setText(text) {
      this.modeInfoNode.textContent = text;
    }
  }, {
    key: 'toggleVisibility',
    value: function toggleVisibility(toggle) {
      if (toggle) {
        this.node.style.display = 'block';
      } else {
        this.node.style.display = 'none';
      }
      if (this.input) {
        this.removeInputListeners();
      }
      clearInterval(this.notifTimeout);
    }
  }, {
    key: 'addInputListeners',
    value: function addInputListeners() {
      var node = this.input.node;
      node.addEventListener('keyup', this.inputKeyUp);
      node.addEventListener('keydown', this.inputKeyDown);
      node.addEventListener('input', this.inputKeyInput);
      node.addEventListener('blur', this.inputBlur);
    }
  }, {
    key: 'removeInputListeners',
    value: function removeInputListeners() {
      if (!this.input || !this.input.node) {
        return;
      }
      var node = this.input.node;
      node.removeEventListener('keyup', this.inputKeyUp);
      node.removeEventListener('keydown', this.inputKeyDown);
      node.removeEventListener('input', this.inputKeyInput);
      node.removeEventListener('blur', this.inputBlur);
    }
  }, {
    key: 'showNotification',
    value: function showNotification(text) {
      var _this2 = this;
      var sp = document.createElement('span');
      sp.innerHTML = text;
      this.notifNode.textContent = sp.textContent;
      this.notifTimeout = setTimeout(function () {
        _this2.notifNode.textContent = '';
      }, 5000);
    }
  }]);
  return VimStatusBar;
}();
exports.default = VimStatusBar;